import Button from '@mui/material/Button';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import UploadFileIcon from '@mui/icons-material/UploadFile';

import { ImportDialog } from '../ImportDialog';

export function ImportSection() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button variant="contained" color="primary" onClick={() => setOpen(true)} startIcon={<UploadFileIcon />}>
        <FormattedMessage id="import.button.button_import" defaultMessage="Import data" />
      </Button>

      <ImportDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
}
